import { atom } from "recoil";

export const headerShowState = atom({
    key: 'headerShow',
    default: true
});